




























import { Component, Provide, Vue } from 'vue-property-decorator';

@Component({
  components: {
    HomeNewAcquisition: () => import('@/components/home/HomeNewAcquisition.vue'),
  },
})
export default class HomeInformations extends Vue {
  startAcquisition() {
    (this.$refs.start as any).open();
  }
}
